import { render, staticRenderFns } from "./ProductIntro.vue?vue&type=template&id=a8ce48c6&scoped=true&"
import script from "./ProductIntro.vue?vue&type=script&lang=js&"
export * from "./ProductIntro.vue?vue&type=script&lang=js&"
import style0 from "./ProductIntro.vue?vue&type=style&index=0&id=a8ce48c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ce48c6",
  null
  
)

export default component.exports